module.exports = __webpack_public_path__ + "img/14b949a.png";